import React, { useEffect, useState } from 'react';

export default function Currency() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-halloween-orange/30 shadow-halloween-purple/10 p-4 w-full">
      <h2 className="font-semibold text-lg mb-2">Tỷ giá ngoại tệ</h2>
      <iframe
        src="https://chogia.vn/ma-nhung-cho-iframe?ma=fr"
        width="100%"
        height="300"
        className="border-none"
        title="Foreign Exchange Rates"
        loading="lazy"
      ></iframe>
    </div>
  );
}
